export default "__VITE_ASSET__2ec33876__"